module.exports = __webpack_public_path__ + "static/media/react.599a1939.png";